import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Start from "./Start";
import TimeOut from "./TimeOut";
import {
    record,
    lostFocus,
    timeOut,
    start,
    retry,
    save
} from "../../../services/quiz";
import Retry from "./Retry";
import Failed from "./Failed";
import Passed from "./Passed";
import Waiting from "../../utilities/Waiting";
class Quiz extends Component {
    state = {
        items: {},
        errors: [],
        start: false,
        retry: false,
        running: false,
        failed: false,
        timerModal: false,
        lostFocus: false,
        passed: false,
        waiting: true,
        timeOut: 60,
        countDown: 1800,
        qsnList: null,
    };

    start = () => {
        start()
            .then(response => {
                this.setState({
                    countDown: response.data.seconds,
                    items: {},
                    running: true,
                    start: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };
    retry = () => {
        retry()
            .then(response => {
                this.setState({
                    countDown: response.data.seconds,
                    items: {},
                    running: true,
                    retry: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };
    close = () => {
        window.close();
    };
    home = () => {
        window.location.href = "/account";
    };
    onChange = field => {
        let temp = this.state.items;
        temp[field.target.name] = field.target.value;
        //console.log( temp);
        this.setState({ items: temp });
    };

    lostFocus = () => {
        lostFocus()
            .then(response => {
                this.checkEvent();
                this.setState({
                    state: null,
                    timerModal: false,
                    lostFocus: false,
                    running: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    timeOut = () => {
        timeOut()
            .then(response => {
                this.checkEvent();
                this.setState({ state: null, timeOut: true, running: false });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    checkEvent = () => {
        record()
            .then(response => {
                switch (response.meta.state) {
                    case "failure":
                        this.setState({ failed: true, qsnList: response.data.failedQsnList });
                        break;
                    case "retry":
                        this.setState({ retry: true, items: {}, qsnList: response.data.failedQsnList });
                        break;
                    case "ready":
                        this.setState({ start: true });
                        break;
                    case "running":
                        this.setState({ running: true });
                        break;
                    case "passed":
                        this.setState({ passed: true });
                        break;
                    default:
                        break;
                }
                this.setState({ waiting: false });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };
    save = () => {
        //console.log(this.state.items);
        this.setState({ running: false });
        save(this.state.items)
            .then(res => {
                this.checkEvent();
            })
            .catch(error => {});
    };
    componentDidMount() {
        this.checkEvent();        
        document.onmousemove = e => {
            this.setState({ timeOut: 60 });
        };

        document.onkeyup = e => {
            this.setState({ timeOut: 60 });
        };

        var countDown = setInterval(() => {
            if (this.state.running === true) {
                countDown = this.state.countDown;
                var timeOut = 0;
                var seconds = 0;
                var minutes = 0;

                countDown = countDown - 1;
                timeOut = this.state.timeOut - 1;
                seconds = countDown % 60;
                minutes = (countDown - seconds) / 60;

                if (minutes >= 0 && seconds >= 0) {
                    if (seconds >= 1) {
                        seconds = seconds - 1;
                    } else {
                        if (minutes > 0) {
                            minutes = minutes - 1;
                            seconds = 59;
                        }
                    }
                } else {
                    minutes = "00";
                    seconds = "00";
                }

                if (countDown === 0) {
                    this.setState({ running: false });
                    this.timeOut();
                }
                if (timeOut <= -60) {
                    this.setState({ running: false });
                    this.lostFocus();
                }
                this.setState({
                    timer: minutes + ":" + seconds,
                    countDown: countDown,
                    timeOut: timeOut,
                    timerModal: timeOut <= 0
                });
            }
        }, 1000);
    }

    render() {
        return (
            <Fragment>
                {this.state.waiting === true ? <Waiting></Waiting> : null}
                {this.state.start === true ? (
                    <Start start={this.start}></Start>
                ) : null}
                {this.state.retry === true ? (
                    <Retry retry={this.retry} questions={this.state.qsnList}></Retry>
                ) : null}
                {this.state.failed === true ? (
                    <Failed close={this.close} questions={this.state.qsnList}></Failed>
                ) : null}
                {this.state.passed === true ? (
                    <Passed  home={this.home}></Passed>
                ) : null}
                {this.state.timerModal === true ? (
                    <TimeOut timeOut={this.state.timeOut}></TimeOut>
                ) : null}
                <div
                    className={
                        this.state.passed === true ||
                        this.state.start === true ||
                        this.state.retry === true ||
                        this.state.failed === true
                            ? "overLayIn"
                            : null
                    }
                >
                    
					<nav className="navbar fixed-top navbar-expand-md navbar-light p-md-0 p-3" id="sidebar">
                        <div className="container-fluid">    
							<a className="navbar-brand d-block mx-auto mb-md-0 mb-3" href="/"><img src="/images/logo.png" alt="Prowriter"/></a>
                            <div className="w-100" id="sidebarCollapse">
                                <div className="d-flex flex-md-row flex-column align-items-center quiz-info pl-md-5">
						    	    <div className="timer-block">
						    		    <h6 className="navbar-heading text-center mb-2">time remaining</h6>
						    			<p className=" text-center" id="CountDown">{this.state.timer}</p>
                                    </div>
						    	    <button
                                        className="btn btn-block btn-primary ml-md-auto mx-md-0 mx-auto mt-md-0 mt-3"
                                        onClick={this.save}
                                    >
                                        Submit
                                    </button>
									<div
                                        className="alert alert-light d-md-none d-block text-center"
                                        role="alert"
                                    >
                                        Do not press back button. Your test
                                        will <br /> be marked as invalid.
                                    </div>
						    	</div>
                            </div>
						</div>	
                    </nav>
					
					<div className="main-content quiz-content">
					    <div id="quiz-area" className="container">
						    <div
                                className="alert alert-light mb-4 d-md-block d-none"
                                role="alert"
                            >
                                Do not click outside of the tab. Your test
                                will <br /> be marked as invalid.
                            </div>
                            <div className="row justify-content-xl-center justify-content-lg-start">
                                <div className="col-xl-7 col-lg-9 col-md-9 col-12">
                                    <div className="m-login__wrapper-1 m-portlet-full-height">
                                        <div className="m-login__wrapper-1-1">
                                            <div
                                                id="QuizArea"
                                                className="m-login__contanier"
                                            >
                                                <form id="QuizForm">
                                                    <div className="header">
                                                        <div className="header-body">
                                                            <h1 className="header-title ">
                                                                Grammar Check
                                                            </h1>
                                                            <h6 className="header-pretitle">
                                                                Select from the
                                                                dropdown the
                                                                correct word or
                                                                phrase to insert
                                                                into the
                                                                sentence.
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div className="m-login__content">
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    Joe
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .a
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 100
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="a"
                                                                    id="a"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Is visit">
                                                                        is visit
                                                                    </option>
                                                                    <option value="Visiting">
                                                                        visiting
                                                                    </option>
                                                                    <option value="Is visiting">
                                                                        is
                                                                        visiting
                                                                    </option>
                                                                    <option value="Are visiting">
                                                                        are
                                                                        visiting
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    his mom
                                                                    today.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    Beth,
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .b
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 100
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="b"
                                                                    id="b"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Picks">
                                                                        picks
                                                                    </option>
                                                                    <option value="Pick">
                                                                        pick
                                                                    </option>
                                                                    <option value="Picked">
                                                                        picked
                                                                    </option>
                                                                    <option value="Will picking">
                                                                        will
                                                                        picking
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    up the
                                                                    phone.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    My boss
                                                                    asked me to
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .c
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 100
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="c"
                                                                    id="c"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Sent">
                                                                        sent
                                                                    </option>
                                                                    <option value="Sends">
                                                                        sends
                                                                    </option>
                                                                    <option value="Send">
                                                                        send
                                                                    </option>
                                                                    <option value="To send">
                                                                        to send
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    this email
                                                                    yesterday.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    Each of the
                                                                    performers
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .d
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 250
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="d"
                                                                    id="d"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Has been practicing">
                                                                        has been
                                                                        practicing
                                                                    </option>
                                                                    <option value="Practicing daily">
                                                                        practicing daily
                                                                    </option>
                                                                    <option value="Been practicing">
                                                                        been practicing
                                                                    </option>
                                                                    
                                                                    <option value="Was practicing">
                                                                        was practicing
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    for months.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    The company
                                                                    will upgrade
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .e
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 100
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="e"
                                                                    id="e"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="There">
                                                                        there
                                                                    </option>
                                                                    <option value="They’re">
                                                                        they’re
                                                                    </option>
                                                                    <option value="Its">
                                                                        its
                                                                    </option>
                                                                    <option value="It’s">
                                                                        it’s
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    computer
                                                                    information
                                                                    systems next
                                                                    month.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    You can use
                                                                    my car
                                                                </span>
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .f
                                                                    }
                                                                    style={{
                                                                        width: 100
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="f"
                                                                    id="f"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Yet">
                                                                        yet
                                                                    </option>
                                                                    <option value="Since">
                                                                        since
                                                                    </option>
                                                                    <option value="Until">
                                                                        until
                                                                    </option>
                                                                    <option value="Around">
                                                                        around
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    tomorrow.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="m-login__content">
                                                        <div className="header">
                                                            <div className="header-body">
                                                                <h1 className="header-title ">
                                                                    Find What’s
                                                                    Wrong
                                                                </h1>
                                                                <h6 className="header-pretitle">
                                                                    Select the
                                                                    word that is
                                                                    incorrect in
                                                                    each
                                                                    sentence.
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .g
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 120,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="g"
                                                                    id="g"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="The">
                                                                        the
                                                                    </option>
                                                                    <option value="To">
                                                                        to
                                                                    </option>
                                                                    <option value="News">
                                                                        news
                                                                    </option>
                                                                    <option value="Negative">
                                                                        negative
                                                                    </option>
                                                                </select>
                                                                <div className="float-left">
                                                                    {" "}
                                                                    The majority
                                                                    to the news
                                                                    is extremely
                                                                    negative .
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .h
                                                                    }
                                                                    style={{
                                                                        width: 120,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="h"
                                                                    id="h"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Swimmed">
                                                                        swimmed
                                                                    </option>
                                                                    <option value="Dozen">
                                                                        dozen
                                                                    </option>
                                                                    <option value="In">
                                                                        in
                                                                    </option>
                                                                    <option value="Morning">
                                                                        morning
                                                                    </option>
                                                                </select>
                                                                <div className="float-left">
                                                                    Sally
                                                                    swimmed a
                                                                    dozen laps
                                                                    in the pool
                                                                    this morning
                                                                    .
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .i
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 120,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="i"
                                                                    id="i"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Is">
                                                                        is
                                                                    </option>
                                                                    <option value="A">
                                                                        a
                                                                    </option>
                                                                    <option value="For">
                                                                        for
                                                                    </option>
                                                                    <option value="Ambulance">
                                                                        ambulance
                                                                    </option>
                                                                </select>
                                                                <div className="float-left">
                                                                    Stan is
                                                                    calling a
                                                                    ambulance
                                                                    for help{" "}
                                                                </div>
                                                                .
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .j
                                                                    }
                                                                    style={{
                                                                        width: 120,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="j"
                                                                    id="j"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Intends">
                                                                        intends
                                                                    </option>
                                                                    <option value="Starting">
                                                                        starting
                                                                    </option>
                                                                    <option value="Own">
                                                                        own
                                                                    </option>
                                                                    <option value="Few">
                                                                        few
                                                                    </option>
                                                                </select>
                                                                <div className="float-left">
                                                                    Tom intends
                                                                    to starting
                                                                    his own
                                                                    company in a
                                                                    few years.{" "}
                                                                </div>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="m-login__content">
                                                        <div className="header">
                                                            <div className="header-body">
                                                                <h1 className="header-title ">
                                                                    The Best
                                                                    Words
                                                                </h1>
                                                                <h6 className="header-pretitle">
                                                                    Select the
                                                                    word or
                                                                    words that
                                                                    are most
                                                                    appropriate
                                                                    for each
                                                                    sentence
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    Wow, the
                                                                    rate of
                                                                </span>
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .k
                                                                    }
                                                                    style={{
                                                                        width: 120
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="k"
                                                                    id="k"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Money">
                                                                        money
                                                                    </option>
                                                                    <option value="coins">
                                                                        coins
                                                                    </option>
                                                                    <option value="Bills">
                                                                        bills
                                                                    </option>
                                                                    <option value="Exchange">
                                                                        exchange
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    {" "}
                                                                    has been all
                                                                    over the
                                                                    place this
                                                                    week.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    A funny
                                                                    friend will
                                                                    have you
                                                                </span>
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .l
                                                                    }
                                                                    style={{
                                                                        width: 120
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="l"
                                                                    id="l"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Putting too many irons in the fire.">
                                                                        putting
                                                                        too many
                                                                        irons in
                                                                        the
                                                                        fire.
                                                                    </option>
                                                                    <option value="Keeping your nose out of someone’s business.">
                                                                        keeping
                                                                        your
                                                                        nose out
                                                                        of
                                                                        someone’s
                                                                        business.
                                                                    </option>
                                                                    <option value="Rolling on the floor">
                                                                        rolling
                                                                        on the
                                                                        floor.
                                                                    </option>
                                                                    <option value="Going to bat for someone.">
                                                                        going to
                                                                        bat for
                                                                        someone.
                                                                    </option>
                                                                </select>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    We knew we
                                                                    were
                                                                </span>
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .m
                                                                    }
                                                                    style={{
                                                                        width: 120
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="m"
                                                                    id="m"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Upon">
                                                                        upon
                                                                    </option>
                                                                    <option value="Among">
                                                                        among
                                                                    </option>
                                                                    <option value="Toward">
                                                                        toward
                                                                    </option>
                                                                    <option value="In addition to">
                                                                        in
                                                                        addition
                                                                        to
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    friends in
                                                                    this strange
                                                                    place.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    The tornado
                                                                    caused
                                                                </span>
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .n
                                                                    }
                                                                    style={{
                                                                        width: 120
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="n"
                                                                    id="n"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Extend">
                                                                        extend
                                                                    </option>
                                                                    <option value="Extending">
                                                                        extending
                                                                    </option>
                                                                    <option value="Extensive">
                                                                        extensive
                                                                    </option>
                                                                    <option value="Extension">
                                                                        extension
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    damage to
                                                                    the city.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <span className="float-left">
                                                                    Many
                                                                    cultures
                                                                    have rituals
                                                                    to celebrate
                                                                    one’s
                                                                </span>
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .o
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 120
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="o"
                                                                    id="o"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Right">
                                                                        right
                                                                    </option>
                                                                    <option value="Rite">
                                                                        rite
                                                                    </option>
                                                                    <option value="Writ">
                                                                        writ
                                                                    </option>
                                                                    <option value="write">
                                                                        write
                                                                    </option>
                                                                </select>
                                                                <span>
                                                                    of passage
                                                                    into
                                                                    adulthood.
                                                                </span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div className="m-login__content">
                                                        <div className="header">
                                                            <div className="header-body">
                                                                <h1 className="header-title ">
                                                                    Reading
                                                                    Comprehension
                                                                    Prompt #1
                                                                </h1>
                                                                <h6 className="header-pretitle">
                                                                    Carefully
                                                                    read the
                                                                    paragraph
                                                                    below and
                                                                    then answer
                                                                    the
                                                                    questions
                                                                    that follow
                                                                    it.
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            Spend ten romantic
                                                            days enjoying the
                                                            lush countryside of
                                                            southern England.
                                                            The counties of
                                                            Devon, Dorset,
                                                            Hampshire, and Essex
                                                            invite you to enjoy
                                                            their castles and
                                                            coastline, their
                                                            charming bed and
                                                            breakfast inns,
                                                            their museums and
                                                            their cathedrals.
                                                            Spend lazy days
                                                            watching the clouds
                                                            drift by or spend
                                                            active days hiking
                                                            the glorious hills.
                                                            These fields were
                                                            home to Thomas
                                                            Hardy, and the ports
                                                            launched ships that
                                                            shaped world
                                                            history. Bed and
                                                            breakfasts abound,
                                                            ranging from quiet
                                                            farmhouses to lofty
                                                            castles. Our tour
                                                            begins August 15.
                                                            Call or fax us today
                                                            for more information
                                                            1-800-222-XXXX.
                                                            Enrollment is
                                                            limited, so please
                                                            call soon.
                                                        </p>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .p
                                                                    }
                                                                    style={{
                                                                        width: 220,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="p"
                                                                    id="p"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="Devon">
                                                                        Devon
                                                                    </option>
                                                                    <option value="Cornwall">
                                                                        Cornwall
                                                                    </option>
                                                                    <option value="Essex">
                                                                        Essex
                                                                    </option>
                                                                    <option value="Hampshire">
                                                                        Hampshire
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    {" "}
                                                                    Which of the
                                                                    following
                                                                    counties is
                                                                    not included
                                                                    in the tour?
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .q
                                                                    }
                                                                    style={{
                                                                        width: 220,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="q"
                                                                    id="q"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="10">
                                                                        10
                                                                    </option>
                                                                    <option value="As many as you want">
                                                                        As many
                                                                        as you
                                                                        want
                                                                    </option>
                                                                    <option value="2-8">
                                                                        2-8
                                                                    </option>
                                                                    <option value="A limited number">
                                                                        A
                                                                        limited
                                                                        number
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    How many
                                                                    people can
                                                                    go on this
                                                                    tour?
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .r
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 220,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="r"
                                                                    id="r"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="The region has lots of vegetation">
                                                                        The
                                                                        region
                                                                        has lots
                                                                        of
                                                                        vegetation
                                                                    </option>
                                                                    <option value="The coast often has harsh weather">
                                                                        The
                                                                        coast
                                                                        often
                                                                        has
                                                                        harsh
                                                                        weather
                                                                    </option>
                                                                    <option value="The sun is hot and the air is dry">
                                                                        The sun
                                                                        is hot
                                                                        and the
                                                                        air is
                                                                        dry
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    What can we
                                                                    infer about
                                                                    the area?
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="header">
                                                            <div className="header-body">
                                                                <h1 className="header-title ">
                                                                    Reading
                                                                    Comprehension
                                                                    Prompt #2
                                                                </h1>
                                                                <h6 className="header-pretitle">
                                                                    Carefully
                                                                    read the
                                                                    paragraph
                                                                    below and
                                                                    then answer
                                                                    the
                                                                    questions
                                                                    that follow
                                                                    it.
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <p>
                                                            Anna Taylor, perhaps
                                                            the most popular
                                                            broadcaster in the
                                                            news media today,
                                                            won the 1998
                                                            Broadcasting Award.
                                                            She got her start in
                                                            journalism as an
                                                            editor at the County
                                                            Times in Missouri.
                                                            When the newspaper
                                                            went out of
                                                            business, a
                                                            colleague persuaded
                                                            her to enter the
                                                            field of
                                                            broadcasting. She
                                                            moved to Oregon to
                                                            begin a master's
                                                            degree in broadcast
                                                            journalism at Oregon
                                                            University.
                                                            Following
                                                            graduation, she was
                                                            able to begin her
                                                            career as a local
                                                            newscaster with
                                                            WBU-TV in Seattle,
                                                            Washington, and
                                                            rapidly advanced to
                                                            national television.
                                                            Noted for her quick
                                                            wit and trenchant
                                                            commentary, her name
                                                            has since become
                                                            synonymous with Good
                                                            Morning America!
                                                            Accepting the award
                                                            at the National
                                                            Convention of
                                                            Broadcast Journalism
                                                            held in Chicago, Ms.
                                                            Taylor remarked, "I
                                                            am so honored by
                                                            this award that I'm
                                                            at a total loss for
                                                            words!" Who would
                                                            ever have believed
                                                            it?
                                                        </p>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .s
                                                                    }
                                                                    style={{
                                                                        width: 240,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="s"
                                                                    id="s"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="To invite people to the National Convention of Broadcast Journalism">
                                                                        To
                                                                        invite
                                                                        people
                                                                        to the
                                                                        National
                                                                        Convention
                                                                        of
                                                                        Broadcast
                                                                        Journalism
                                                                    </option>
                                                                    <option value="To encourage college students to study broadcasting">
                                                                        To
                                                                        encourage
                                                                        college
                                                                        students
                                                                        to study
                                                                        broadcasting
                                                                    </option>
                                                                    <option value="To recognize Ms. Taylor`s accomplishments">
                                                                        To
                                                                        recognize
                                                                        Ms.
                                                                        Taylor’s
                                                                        accomplishments
                                                                    </option>
                                                                    <option value="To advertise a job opening at the County Times">
                                                                        To
                                                                        advertise
                                                                        a job
                                                                        opening
                                                                        at the
                                                                        County
                                                                        Times
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    What is the
                                                                    purpose of
                                                                    this
                                                                    announcement?
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .t
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 240,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="t"
                                                                    id="t"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="To be the same as">
                                                                        To be
                                                                        the same
                                                                        as
                                                                    </option>
                                                                    <option value="To be the opposite of">
                                                                        To be
                                                                        the
                                                                        opposite
                                                                        of
                                                                    </option>
                                                                    <option value="To be in sympathy with">
                                                                        To be in
                                                                        sympathy
                                                                        with
                                                                    </option>
                                                                    <option value="To be discharged from">
                                                                        To be
                                                                        discharged
                                                                        from
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    The
                                                                    expression
                                                                    "to become
                                                                    synonymous
                                                                    with" means:
                                                                </div>
                                                            </h5>
                                                        </div>
                                                        <div className="m-login__titles">
                                                            <h5 className="QuestionContent">
                                                                <select
                                                                    onChange={
                                                                        this
                                                                            .onChange
                                                                    }
                                                                    style={{
                                                                        width: 240,
                                                                        marginLeft: 0
                                                                    }}
                                                                    className="form-control m-input center-select"
                                                                    name="u"
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .items
                                                                            .u
                                                                    }
                                                                    id="u"
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="She was a TV announcer in Washington">
                                                                        She was
                                                                        a TV
                                                                        announcer
                                                                        in
                                                                        Washington
                                                                    </option>
                                                                    <option value="She was a newscaster in Oregon">
                                                                        She was
                                                                        a
                                                                        newscaster
                                                                        in
                                                                        Oregon
                                                                    </option>
                                                                    <option value="She was an editor for a newspaper in Missouri">
                                                                        She was
                                                                        an
                                                                        editor
                                                                        for a
                                                                        newspaper
                                                                        in
                                                                        Missouri
                                                                    </option>
                                                                    <option value="She was a talk show host in Chicago.">
                                                                        She was
                                                                        a talk
                                                                        show
                                                                        host in
                                                                        Chicago.
                                                                    </option>
                                                                </select>
                                                                <div>
                                                                    What was Ms.
                                                                    Taylor’s
                                                                    first job in
                                                                    journalism?
                                                                </div>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
Quiz.contextType = AppContext;
export default Quiz;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/Quiz.js